module.exports = __webpack_public_path__ + "static/media/Logo-M.3c07b89f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Logo-M.png
// module id = 801
// module chunks = 0